import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

const UserCellDisplay = ({ user }) => {
	const initials =
		`${user.first_name?.[0] || ''}${user.last_name?.[0] || ''}`.toUpperCase();
	const fullName =
		`${user.first_name?.trim() || ''} ${user.last_name?.trim() || ''}`.trim();

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: 1.5,
				py: 1,
			}}
		>
			{/* Avatar with initials */}
			<Box
				sx={{
					width: 25,
					height: 25,
					borderRadius: '50%',
					backgroundColor: '#E8E0F5', // Light purple
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexShrink: 0,
				}}
			>
				<Typography
					data-testid='user-initials'
					sx={{
						color: '#6B46C1', // Darker purple
						fontWeight: 600,
						letterSpacing: '0.5px',
						fontSize: '11px',
					}}
				>
					{initials}
				</Typography>
			</Box>

			{/* Name and email */}
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					overflow: 'hidden',
				}}
			>
				<Typography
					data-testid='user-name'
					sx={(theme) => ({
						fontWeight: 600,
						fontSize: '12px',
						color: theme.palette.text.primary,
						textTransform: 'capitalize',
						lineHeight: 1.2,
					})}
				>
					{fullName || ''}
				</Typography>
				<Typography
					data-testid='user-email'
					sx={(theme) => ({
						fontSize: '12px',
						color: theme.palette.text.secondary,
						lineHeight: 1.4,
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
					})}
				>
					{user.email || ''}
				</Typography>
			</Box>
		</Box>
	);
};

UserCellDisplay.propTypes = {
	user: PropTypes.object.isRequired,
};

export default UserCellDisplay;
